/**
 * ============================================================================
 * User 模块 - 常量定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义枚举标签映射（中文显示）
 * - 定义权限常量
 * 
 * 📖 对应后端：
 * - Model: backend/app/Models/User.php (静态属性)
 * - Migration: backend/database/migrations/0001_01_01_000000_create_users_table.php
 * 
 * ⚠️ 注意事项：
 * - 标签对象命名：{MODULE}_{ENUM}_LABELS（全大写）
 * - 权限常量命名：{MODULE}_PERMISSIONS（全大写）
 * - 使用 `as const` 保证类型推断
 * - 枚举标签的 key 必须与 enums.ts 中的枚举值对应
 * 
 * 🔄 更新时机：
 * - enums.ts 新增枚举值时（同步新增标签）
 * - 后端权限定义变化时
 * - 中文标签需要修改时
 * 
 * ✅ 验证方式：
 * 让AI执行以下检查：
 * 1. 读取 backend/database/migrations/0001_01_01_000000_create_users_table.php
 * 2. 检查状态字段的注释，确认中文标签是否一致
 * 3. 检查本文件的 LABELS 对象是否包含所有映射
 * 
 * @module types/user/constants
 * @generated Manual (AI-assisted)
 * @last-updated 2025-10-18
 * ============================================================================
 */

import { UserStatus } from './enums'

/**
 * 用户状态标签映射
 */
export const USER_STATUS_LABELS = {
  [UserStatus.DISABLED]: '禁用',
  [UserStatus.ACTIVE]: '正常',
} as const

/**
 * ⚠️ 用户权限常量已迁移至统一权限管理
 * 
 * 请从 @bayes-mes/shared 导入标准权限常量：
 * - PERM_SYSTEM_USER_VIEW
 * - PERM_SYSTEM_USER_CREATE
 * - PERM_SYSTEM_USER_UPDATE
 * - PERM_SYSTEM_USER_DELETE
 * 
 * @deprecated 请使用 constants/api-permissions.ts 中的权限常量
 * @see bayes-mes-shared/constants/api-permissions.ts
 */

